/**
 * Asegura que el loop de cada .lm-marquee sea continuo, sin espacio vacío
 * al completar una vuelta: clona el set base las veces necesarias hasta
 * cubrir al menos el ancho visible, y luego duplica ese bloque una vez
 * más para el loop -50% sin costuras.
 */
(function () {
  const SAFETY_MARGIN = 20;

  function buildMarquee(root) {
    const track = root.querySelector('.lm-marquee__track');
    const baseSet = root.querySelector('.lm-marquee__set');
    if (!track || !baseSet) return;

    track.querySelectorAll('.lm-marquee__set:not(:first-child)').forEach((el) => el.remove());

    const containerWidth = root.offsetWidth;
    const baseWidth = baseSet.offsetWidth;
    if (!containerWidth || !baseWidth) return;

    let unitWidth = baseWidth;
    while (unitWidth < containerWidth + SAFETY_MARGIN) {
      track.appendChild(baseSet.cloneNode(true));
      unitWidth += baseWidth;
    }

    Array.from(track.children).forEach((set) => {
      track.appendChild(set.cloneNode(true));
    });
  }

  function init() {
    document.querySelectorAll('.lm-marquee').forEach(buildMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(init, 200);
  });
})();
